import { TherapistSectionList } from "../types";

export const TherapistClientProfileSections: TherapistSectionList = {
    contactDetails: {
        categories_identifier: [
            "personalInfoCtg",
            "personalInformationExistingClientCtg",
            "personalInfoSelfMatchingCtg",
        ],
        pageIdentifier: [
            "contactInformationPg",
            "contactInformationSelfMatchingClientPg",
        ],
        question_identifier: [
            "phonenumberQuestion",
            "phonenumberSelfMatchingClientQuestionV1",
        ],
    },
    prefferedLanguages: {
        categories_identifier: [
            "personalInfoCtg",
            "personalInformationExistingClientCtg",
            "personalInfoSelfMatchingCtg",
        ],
        pageIdentifier: "languagesPgV1",
        question_identifier: "preferredLanguageClientQuestion",
    },
    preferredTherapistIdentities: {
        categories_identifier: "identityCtg",
        pageIdentifier: "therapistIdentityPreferencesPg",
        question_identifier: "preferredGenderClientQuestion",
    },
    genderIdentities: {
        categories_identifier: "identityCtg",
        pageIdentifier: "clientIdentityPg",
        question_identifier: "genderClientQuestion",
    },
    religiousIdentities: {
        categories_identifier: "identityCtg",
        pageIdentifier: "religiousIdentityPg",
        question_identifier: "religionClientQuestion",
    },
    sexualityIdentities: {
        categories_identifier: "identityCtg",
        pageIdentifier: "clientIdentityPgV1",
        question_identifier: "sexualClientQuestionV1",
    },
    culturalIdentities: {
        categories_identifier: "identityCtg",
        pageIdentifier: "culturalIdentityPg",
        question_identifier: "culturalClientQuestion",
    },
    relationshipIdentities: {
        categories_identifier: "identityCtg",
        pageIdentifier: "relationshipIdentityPg",
        question_identifier: "relationshipIdentitiesClientQuestion",
    },
    amountPreviousTherapy: {
        categories_identifier: [
            "personalInfoCtg",
            "personalInformationExistingClientCtg",
            "personalInfoSelfMatchingCtg",
        ],
        pageIdentifier: ["previousExperiencePg", "previousExperiencePgV1"],
        question_identifier: "approxPreviousExperienceQuestion",
    },
    previousTheExpInc: {
        categories_identifier: [
            "personalInfoCtg",
            "personalInformationExistingClientCtg",
            "personalInfoSelfMatchingCtg",
        ],
        pageIdentifier: ["previousExperiencePg"],
        question_identifier: "previousExperiencePart3Question",
    },
    otherConcerns: {
        categories_identifier: "concernsCtg",
        pageIdentifier: "motivatingConcernsPg",
        question_identifier: "moodEmotionalRegQuestion",
    },
    primaryConcerns: {
        categories_identifier: "concernsCtg",
        pageIdentifier: "mostImportantConcernPg",
        question_identifier: "mostImpConcernQuestion",
    },
    secondaryConcerns: {
        categories_identifier: "concernsCtg",
        pageIdentifier: "top3ConcernsPg",
        question_identifier: "top3ConcernsQuestion",
    },
    preferTherapist: {
        categories_identifier: "personalityCtg",
        pageIdentifier: "clientTherapistPreferencesPg",
        question_identifier: "supportiveChallengingClientQuestion",
    },
    profileData: {
        categories_identifier: [
            "personalInfoCtg",
            "personalInformationExistingClientCtg",
            "personalInfoSelfMatchingCtg",
        ],
        pageIdentifier: "profilePicturePgV1",
        question_identifier: "profilePictureQuestionV1",
    },
    therapyExperiences: {
        categories_identifier: [
            "personalInfoCtg",
            "personalInformationExistingClientCtg",
            "personalInfoSelfMatchingCtg",
        ],
        pageIdentifier: "overallTherapyExperiencePg",
        question_identifier: "therapyHelpfulConcernP1",
    },
    pronounceData: {
        categories_identifier: [
            "personalInfoCtg",
            "personalInformationExistingClientCtg",
            "personalInfoSelfMatchingCtg",
        ],
        pageIdentifier: [
            "basicInformationPg",
            "basicInformationExistingClientPg",
        ],
        question_identifier: "clientPronounQuestionV1",
    },
    useFulTheraphy: {
        categories_identifier: [
            "personalInfoCtg",
            "personalInformationExistingClientCtg",
            "personalInfoSelfMatchingCtg",
        ],
        pageIdentifier: "overallTherapyExperiencePg",
        question_identifier: "therapyHelpfulConcernP2",
    },
    notUseFulTheraphy: {
        categories_identifier: [
            "personalInfoCtg",
            "personalInformationExistingClientCtg",
            "personalInfoSelfMatchingCtg",
        ],
        pageIdentifier: "overallTherapyExperiencePg",
        question_identifier: "therapyNoHelpfulConcern",
    },
    age: {
        categories_identifier: [
            "personalInfoCtg",
            "personalInformationExistingClientCtg",
            "personalInfoSelfMatchingCtg",
        ],
        pageIdentifier: [
            "basicInformationPg",
            "basicInformationExistingClientPg",
        ],
        question_identifier: [
            "dateOfBirthNewClientQuestionV1",
            "dateOfBirthQuestionV1",
        ],
    },
    insurance: {
        categories_identifier: [
            "meetingPreferencesCtgV1",
            "practicePaperworkExisitngClientCtg",
            "practicePaperworkSelfMatchingClientCtg",
        ],
        pageIdentifier: [
            "paymentInsuranceNewClientPg",
            "useInsuranceExistingClientPg",
            "useInsuranceSelfMatchingClientPg",
        ],
        question_identifier: [
            "paymentInsuranceNewClientPg",
            "paymentInsuranceExistingClientQuestionV1",
            "paymentInsuranceSelfMatchingClientQuestionV1",
        ],
    },
    meetingPreferences: {
        categories_identifier: [
            "meetingPreferencesCtgV1",
            "meetTherapistSelfMatchingClientPg",
            "preferencesSelfMatchingClientCtgFI",
        ],
        pageIdentifier: [
            "schedulingAvailabilityNewClientPg",
            "meetTherapistSelfMatchingClientPg",
        ],
        question_identifier: [
            "clientAvailabilityNewClientQuestionV1",
            "meetTherapistSelfMatchingClientQuestionV1",
        ],
    },
    matchingPriority: {
        categories_identifier: "meetingPreferencesCtgV1",
        pageIdentifier: "paymentInsuranceNewClientPg",
        question_identifier: "insuranceRateNewClientQuestionV1",
    },
};
